import React, { useEffect } from 'react';
import Image from 'next/image';
import Link from 'next/link';

const Impact = ({ data = [] ,testimonialContent}) => {

  useEffect(() => {
    import('bootstrap/dist/js/bootstrap.bundle.min.js');
  }, []);

  return (
    <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
      {/* Carousel indicators */}
      <div className="carousel-indicators">
        {data.map((_, index) => (
          <button
            key={index}
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide-to={index}
            className={index === 0 ? "active" : ""}
            aria-current={index === 0 ? "true" : undefined}
            aria-label={`Slide ${index + 1}`}
          ></button>
        ))}
      </div>

      {/* Carousel items */}
      <div className="carousel-inner">
        {data.map((item, index) => (
          <div key={item.id} className={`carousel-item ${index === 0 ? "active" : ""}`}>
            <div className="row align-items-center">
              <div className="col-xs-12 col-md-6">
                <div className="d-flex gap-4 align-items-center justify-content-center">
                  <div className="before-after">
                    <Image src={item.before_image_path} alt="Before" layout="responsive" width={100} height={100} />
                    <p className="text-center">{testimonialContent?.before}</p>
                  </div>
                  <div className="before-after">
                    <Image src={item.after_image_path} alt="After" layout="responsive" width={100} height={100} />
                    <p className="text-center">{testimonialContent?.after}</p>
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-md-6 pe-5">
                <div className="impact-info">
                  <h3>{item?.name || "Beneficiary"}</h3>
                  <p className="fs-12 opa-7 font-secondary disabled">{testimonialContent?.IAM} {item?.age} {testimonialContent?.YEARSOLD}</p>
                  <div className="d-flex gap-4 font-secondary opa-9">
                    <p><i className="bi bi-emoji-smile pe-1"></i> {/* Gender if available */}</p>
                    <p><i className="bi bi-calendar-check pe-1"></i> {item?.date_of_birth}</p>
                  </div>
                  <p className="opa-7 fs-13 font-secondary mb-4">{item.description}</p>
                  
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Carousel controls */}
      {data.length > 1 && (
        <>
          <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </>
      )}
    </div>
  );
};

export default Impact;
